import React, {Component} from 'react';
import util from 'Utils/commonUtil';

// Components
import {Card, Grid} from '@material-ui/core';
import ProductImage from 'Components/commonOrder/ProductImage';

// Actions
import {T} from 'Actions/translate';

class ProductDetails extends Component {
    state = {};

    getSkuDetails = (cartId) => {
        const {skuDetailsList} = this.props;
        let skuDetails;

        skuDetails =
            skuDetailsList &&
            skuDetailsList.filter((item) => {
                return item.cartId === cartId;
            });

        return skuDetails[0] || '';
    };

    savingPrice = (productInfo) => {
        // let savingPrice = parseFloat(this.getSkuDetails(productInfo.cartId).listPrice || 0.00) - parseFloat(this.getSkuDetails(productInfo.cartId).finalPrice || 0.00);
        let savingPrice =
            parseFloat(productInfo.listPrice || 0.0) -
            parseFloat(productInfo.unitPrice || 0.0);
        return util.toMoney(savingPrice);
    };

    render() {
        const {productList, isTF} = this.props;
        const createMarkup = (text) => ({__html: text});

        return (
            <Card className="product-details-card">
                <Grid
                    className="product-details-title-container no-margin"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="product-details-title" item xs={11}>
                        {isTF ? (
                            <span>
                                <img
                                    src={
                                        new URL(
                                            'Images/online.svg',
                                            import.meta.url,
                                        ).href
                                    }
                                    alt=""
                                />{' '}
                                <label>{T('TFS_goods')}</label>
                            </span>
                        ) : (
                            <span>
                                <img
                                    src={
                                        new URL(
                                            'Images/sp-icon.svg',
                                            import.meta.url,
                                        ).href
                                    }
                                    alt=""
                                />{' '}
                                <label>{T('supply_center_goods')}</label>
                            </span>
                        )}
                        {/* <span>{T('productInfo')}</span> */}
                        <span className="red">
                            {!isTF
                                ? T('order_sc_stock_product_delivery')
                                : T('order_global_product_delivery')}
                        </span>
                    </Grid>
                </Grid>

                {productList &&
                    productList.map((productInfo, index) => {
                        return (
                            <Grid
                                key={index}
                                className="product-details-container"
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid item xs={11}>
                                    <Grid
                                        className="top-content"
                                        container
                                        spacing={0}>
                                        <Grid
                                            className="left-content-grid"
                                            item
                                            xs={3}>
                                            <div className="image-box">
                                                <ProductImage
                                                    src={productInfo.productPic}
                                                    alt={
                                                        productInfo.productName
                                                    }
                                                    key={productInfo.productPic}
                                                />
                                            </div>
                                        </Grid>

                                        <Grid
                                            className="right-content-grid"
                                            item
                                            xs={9}>
                                            <Grid
                                                container
                                                spacing={0}
                                                justify={'space-evenly'}>
                                                <Grid
                                                    className="product-title"
                                                    item
                                                    xs={12}>
                                                    {/*<span>createMarkup(productInfo.productName)</span>*/}
                                                    <div
                                                        dangerouslySetInnerHTML={createMarkup(
                                                            productInfo.productName,
                                                        )}
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid
                                                className="product-info"
                                                container
                                                spacing={0}>
                                                <Grid item xs={7}>
                                                    {T('product_sku_colon')}
                                                    <span>
                                                        {productInfo.sku}
                                                    </span>
                                                </Grid>
                                                {!isTF ? (
                                                    <Grid item xs={5}>
                                                        {T(
                                                            'order_inventory_colon',
                                                        )}
                                                        <span>
                                                            {productInfo.inventory >
                                                            0
                                                                ? productInfo.inventory
                                                                : 0}
                                                        </span>
                                                    </Grid>
                                                ) : null}
                                            </Grid>

                                            <Grid
                                                className="product-info"
                                                container
                                                spacing={0}>
                                                <Grid item xs={12}>
                                                    {T(
                                                        'product_specifications_colon',
                                                    )}
                                                    <span
                                                        dangerouslySetInnerHTML={{
                                                            __html: productInfo.specifications,
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid
                                    className="price-content"
                                    container
                                    spacing={0}>
                                    <Grid
                                        className="price-container"
                                        item
                                        xs={9}>
                                        <Grid
                                            className="price-grid"
                                            container
                                            spacing={0}>
                                            <Grid
                                                className="discount-price"
                                                item
                                                xs={5}>
                                                {/*<span className="price-font"><i className="rmb"></i> <span className="price">{util.toMoney(this.getSkuDetails(productInfo.cartId).finalPrice)}</span> </span><br/>*/}
                                                <span className="price-font">
                                                    <i className="rmb"></i>{' '}
                                                    <span className="price">
                                                        {util.toMoney(
                                                            productInfo.unitPrice,
                                                        )}
                                                    </span>{' '}
                                                </span>
                                                <br />
                                                {T(
                                                    'order_your_preferential_price',
                                                )}
                                            </Grid>

                                            <Grid
                                                className="discount-code"
                                                item
                                                xs={7}>
                                                {this.savingPrice(productInfo) >
                                                '0.00' ? (
                                                    <span>
                                                        {T('order_save_colon', [
                                                            this.savingPrice(
                                                                productInfo,
                                                            ),
                                                        ])}
                                                    </span>
                                                ) : null}
                                            </Grid>
                                            {/*
							      			<Grid className='discount-code' item xs={12}>
								      			<span>促销代码：{this.getSkuDetails(productInfo.cartId).activeCode}</span>
								      		</Grid>*/}
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        className="product-number"
                                        item
                                        xs={3}>
                                        <span>x{productInfo.quantity}</span>
                                    </Grid>
                                </Grid>
                            </Grid>
                        );
                    })}
            </Card>
        );
    }
}

export default ProductDetails;
